module.exports = __webpack_public_path__ + "3f16e137/img/placeholder.888fcd0b.svg";